export default {
  tasks: "งาน",
}